import { baseApi } from "@/services/base-api";
import type { Product, ProductStatus } from "@/features/marketplace/types/product";

export interface MyListingsFilters {
  status?: ProductStatus;
}

export interface UpdateListingInput {
  status?: ProductStatus;
}

/**
 * `docs/api/api-design.md`'s documented `POST/PATCH/DELETE /products` plus
 * one addition it doesn't list: `GET /products/mine` — the public
 * `GET /products` only ever returns `status: "active"` listings
 * (marketplace.api.ts), so a seller's own drafts/sold listings need a
 * separate, authenticated endpoint rather than a filter on the public one.
 */
export const listingsApi = {
  /**
   * Multipart, not JSON — images are real `File` objects. `Content-Type:
   * null` strips base-api's JSON default for this one request so the
   * browser sets the correct header itself, boundary included; a manually
   * set `"multipart/form-data"` value with no boundary would produce a
   * request the server's multer middleware can't parse.
   */
  createListing: (formData: FormData) =>
    baseApi.post<Product, FormData>("/products", formData, {
      headers: { "Content-Type": null },
    }),

  getMyListings: (filters: MyListingsFilters = {}) =>
    baseApi.get<Product[]>("/products/mine", { params: filters }),

  updateListing: (id: string, input: UpdateListingInput) =>
    baseApi.patch<Product>(`/products/${id}`, input),

  deleteListing: (id: string) => baseApi.delete<void>(`/products/${id}`),
};
